
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';

export class TranslateConfig {
  static createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/', '.json');
  }
}
